import { Injectable } from '@angular/core';
import { BackendService } from '../backend/backend.service';

@Injectable({
  providedIn: 'root'
})
export class UploadExamCenterService {

  constructor(private backendService: BackendService) { }

  private path = '/exam-centers';

  saveUploadedExamCenter(uploadexamcenterdata) {
    return this.backendService.post(this.path + '/import', uploadexamcenterdata);
  }

  searchExamCenterList(currPage: number, pageSize: number, filter: any) {

    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter
    };

    return this.backendService.post(this.path + "/search", data);
  }

  getExamcenterById(id) {
    return this.backendService.get(this.path + "/get/" + id);
  };

  saveExamCenter(data) {
    return this.backendService.post(this.path + '/save', data);
  }

  getCandidatesById(currPage:number, pageSize:number,filter: any,centerId) {
    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter,
      centerId: centerId
    };
    return this.backendService.post(this.path + "/candidate", data);
  }

  getUsersById(currPage:number, pageSize:number,filter: any,centerId) {
    var data = {
      pagination: {
        page: currPage,
        size: pageSize
      },
      filter: filter,
      centerId: centerId
    };
    return this.backendService.post(this.path + "/user/", data);
  }

  deleteExamCenter(centerId) {
    return this.backendService.post(this.path + "/delete/" + centerId, {});
  }

  deleteAll(examCenter) {
    return this.backendService.post(this.path + "/delete", examCenter);
  }

  sendPassword(centerId){
    return this.backendService.post(this.path + "/pass/"+ centerId, {});

  }
  

}